'use client';

import {useEffect, useState, useRef} from 'react';

export function useIframeResize() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const el = ref.current;

    const sendHeight = () => {
      const height = el.scrollHeight;

      window.parent.postMessage(
        {
          type: 'PURPOSE_WIDGET_RESIZE',
          height
        },
        '*'
      );
    };

    const observer = new ResizeObserver(() => {
      sendHeight();
    });

    observer.observe(el);
    sendHeight();

    return () => observer.disconnect();
  }, []);

  return ref;
}

export function useSingleColumn(width, gap, paddingX) {
  const ref = useRef<HTMLDivElement>(null);
  const [isSingleColumn, setIsSingleColumn] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const el = ref.current;

    const check = () => {
      const children = Array.from(el.children) as HTMLElement[];

      if (children.length === 0) return;

      const containerWidth = el.clientWidth;

      setIsSingleColumn(containerWidth < width * 2 + gap + paddingX);
    };

    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return {ref, isSingleColumn};
}
